import React from "react";
import { Card, SkeletonThumbnail, SkeletonBodyText, BlockStack } from "@shopify/polaris";

const SkeletonList = () => {
  return (
    <BlockStack gap="400">
      <Card sectioned>
        <BlockStack gap="200">
          <SkeletonThumbnail size="large" />
          <SkeletonBodyText />
        </BlockStack>
      </Card>
      <Card sectioned>
        <BlockStack gap="200">
          <SkeletonThumbnail size="large" />
          <SkeletonBodyText />
        </BlockStack>
      </Card>
      <Card sectioned>
        <BlockStack gap="200">
          <SkeletonThumbnail size="large" />
          <SkeletonBodyText />
        </BlockStack>
      </Card>
    </BlockStack>
  );
};

export default SkeletonList;
